import { Pagination } from "antd";
import { BaseTable } from "../TableComponents";
import {
  NexPaginationButton,
  PaginationButton,
  PreviousPaginationButton,
} from "..";
import { useTableContext } from "@/common/contexts/Table.context";
import { DocumentsTableProps } from "@/common/types/componentsProps/DocumentsTableProps.type";

export default function DocumentsTable({
  total,
  items,
  strategy,
}: DocumentsTableProps) {
  const { changePage, currentPage } = useTableContext();

  return (
    <div>
      <BaseTable data={!!items ? items : []} strategy={strategy} />
      <div className="my-5 flex justify-between items-center">
        <div className="mx-auto max-w-fit">
          {Boolean(total && total > 10) && (
            <Pagination
              onChange={changePage}
              current={currentPage + 1}
              total={total}
              defaultPageSize={10}
              pageSize={10}
              align="center"
              showSizeChanger={false}
              itemRender={(page, type, originalElement) => {
                switch (type) {
                  case "next":
                    return <NexPaginationButton />;
                  case "prev":
                    return <PreviousPaginationButton />;
                  case "page":
                    return (
                      <PaginationButton current={currentPage + 1} page={page} />
                    );
                  default:
                    return originalElement;
                }
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
